import ModuleWrapper from 'shared-lib/containers/Module';

const Advertisers = () => import(/* webpackChunkName: "advertisers-default" */ '@/views/advertisers/Advertisers');
const AdvertiserDetails = () => import(/* webpackChunkName: "advertiser-details" */ '@/views/advertisers/AdvertiserDetails');
const AdvertiserAdd = () => import(/* webpackChunkName: "add-advertiser" */ '@/views/advertisers/AdvertiserAdd');
const AdvertiserEdit = () => import(/* webpackChunkName: "edit-advertiser" */ '@/views/advertisers/AdvertiserEdit');

const AdvertiserExternalIntegrationAdd = () => import(/* webpackChunkName: "add-external-integration" */ '@/views/advertisers/externalIntegrations/ExternalIntegration01Add');
const AdvertiserExternalIntegrationPreviewOffers = () => {
    return import(/* webpackChunkName: "preview-external-integration" */ '@/views/advertisers/externalIntegrations/ExternalIntegration02PreviewOffers');
};
const AdvertiserExternalIntegrationSync = () => import(/* webpackChunkName: "sync-external-integration" */ '@/views/advertisers/externalIntegrations/ExternalIntegration03Sync');
const AdvertiserExternalIntegrationEdit = () => import(/* webpackChunkName: "edit-external-integration" */ '@/views/advertisers/externalIntegrations/ExternalIntegrationEdit');

const AddOffer = () => import(/* webpackChunkName: "add-offer" */ '@/views/offers/AddOffer');
const meta = (data = {}) => ({
    permissionsModuleName: 'advertisers',
    auth: true,
    ...data,
});

export default [{
    path: 'advertisers',
    component: ModuleWrapper,
    meta: meta({
        permission: 'list',
        title: 'Advertisers',
    }),
    children: [
        {
            path: '',
            name: 'Advertisers',
            component: Advertisers,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: 'add',
            name: 'Add Advertiser',
            component: AdvertiserAdd,
            meta: meta({
                permission: 'create',
            }),
        },
        {
            path: ':id(\\d+)/edit',
            name: 'Edit Advertiser',
            component: AdvertiserEdit,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':advertiserId(\\d+)/external-integration/add',
            name: 'AdvertiserExternalIntegrationAdd',
            component: AdvertiserExternalIntegrationAdd,
            props: true,
            meta: meta(),
        },
        {
            path: ':advertiserId(\\d+)/external-integration/:configurationId(\\d+)/accept-offers/:taskIdProp(\\d+)',
            name: 'AdvertiserExternalIntegrationSync',
            component: AdvertiserExternalIntegrationSync,
            props: true,
            meta: meta(),
        },
        {
            path: ':advertiserId(\\d+)/external-integration/:configurationIdProp(\\d+)/preview-offers',
            name: 'AdvertiserExternalIntegrationPreviewOffers',
            component: AdvertiserExternalIntegrationPreviewOffers,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':advertiserId(\\d+)/external-integration/:configurationId(\\d+)/edit',
            name: 'AdvertiserExternalIntegrationEdit',
            component: AdvertiserExternalIntegrationEdit,
            props: true,
            meta: meta({
                permission: 'update',
            }),
        },
        {
            path: ':id(\\d+)',
            name: 'Advertiser Details',
            component: AdvertiserDetails,
            props: true,
            meta: meta({
                permission: 'list',
            }),
        },
        {
            path: ':id(\\d+)/add-offer',
            name: 'Add Offer',
            component: AddOffer,
            props: true,
            meta: meta({
                permission: 'create',
            }),
        },
    ],
}];


